import Modal from 'react-bootstrap/Modal';
import ActionButtonGradient from '../components/button/ActionButtonGradient';

const UnauthorizedModal = ({show, closePopup, logout}) => {
  return (
    <>
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>Unathorized</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Your login session has expired.</p>
          <p>Please re-enter your email and password to log in again.</p>
        </Modal.Body>
        <Modal.Footer>
          <ActionButtonGradient
            variant="primary"
            onClick={() => {
              closePopup(false)
              logout()
            }}
            children={"Login"}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UnauthorizedModal